/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const OpenidIconConfig = {
  name: 'OpenidIcon',
  height: 512,
  width: 448,
  svgPath: 'M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(OpenidIconConfig);
//# sourceMappingURL=openid-icon.js.map